// extracted by mini-css-extract-plugin
export default {"productDescription":"daa-z","featuredDescription":"eaa-z","description":"faa-z","more":"gaa-z","descriptionSku":"haa-z"};